import React, { useState } from "react";
import styles from "./Home.module.css";
import appartment from "../../assets/services/appartments.webp";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
// import from material-ui icons
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";

function Home() {
    const [value, setValue] = useState(0);
    const categories = [
        {
            title: "",
            img: appartment,
            className: styles.appartment,
        },
        {
            title: "",
            img: "",
            className: styles.restaurants,
        },
        {
            title: "",
            img: "",
            className: styles.nightLife,
        },
        {
            title: "",
            img: "",
            className: styles.shopping,
        },
        {
            title: "",
            img: "",
            className: styles.services,
        },
        {
            title: "",
            img: "",
            className: styles.events,
        },
        {
            title: "",
            img: "",
            className: styles.activities,
        },
    ];

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Tellmiz</h1>
            <div className={styles.categories}>
                {categories.map((category, index) => (
                    <div key={index} className={category.className}>
                        <h2 className={styles.categoryTitle}>
                            {category.title}
                        </h2>
                    </div>
                ))}
            </div>
            <Paper
                sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
                elevation={3}
            >
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        // console.log(event, newValue)
                        setValue(newValue);
                        console.log(newValue)
                    }}
                    className={styles.bottomNavigation}
                >
                    <BottomNavigationAction
                        label="Recents"
                        icon={<RestoreIcon />}
                        className={styles.bottomNavigationAction}
                        />
                    <BottomNavigationAction
                        label="Favorites"
                        icon={<FavoriteIcon />}
                        className={styles.bottomNavigationAction}
                        />
                    <BottomNavigationAction
                        label="Nearby"
                        icon={<LocationOnIcon />}
                        className={styles.bottomNavigationAction}
                    />
                    <BottomNavigationAction
                        label="VIPs"
                        icon={<LocationOnIcon />}
                        className={styles.bottomNavigationAction}
                        // Add a navigation link to the VIPs page
                        href="/vips"
                    />
                </BottomNavigation>
            </Paper>
        </div>
    );
}

export default Home;
